import { Capacitor } from "@capacitor/core";
import { App } from "@capacitor/app";

// Identifica o cliente da chamada pra API: 'Browser' ou 'App - v1.1.2'.
// Fica fora de `axios.defaults.headers` de propósito — header custom obriga
// preflight de CORS, e no default global pegaria carona em qualquer chamada
// futura a um terceiro.
export const CLIENT_HEADER = "X-Origin-Request";

// Promise única, resolvida na importação e reusada por toda request: quem dá o
// await é o interceptor. Sem a versão, 'App' puro ainda distingue app de site.
export const clientDescriptor = Capacitor.isNativePlatform()
  ? App.getInfo()
      .then((info) => (info.version ? `App - v${info.version}` : "App"))
      .catch(() => "App")
  : Promise.resolve("Browser");
